export default "__VITE_ASSET__BzhxZTrz__"